import { useState } from "react";
import { Button } from "./button";
import { Copy, Check } from "lucide-react";
import { useToast } from "../ui/use-toast";

interface CopyIdButtonProps {
  id: string | undefined;
  truncateLength?: number;
  className?: string;
  size?: "default" | "sm" | "lg" | "icon";
  variant?: "default" | "destructive" | "outline" | "secondary" | "ghost" | "link";
}

export function CopyIdButton({
  id,
  truncateLength = 5,
  className = "",
  size = "sm",
  variant = "ghost",
}: CopyIdButtonProps) {
  const [copied, setCopied] = useState(false);
  const { toast } = useToast();

  if (!id) return null;

  const handleCopy = () => {
    navigator.clipboard.writeText(id).then(() => {
      setCopied(true);
      toast({
        title: "המזהה הועתק!",
        description: "מזהה החשבון הועתק ללוח",
      });
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <Button 
      variant={variant} 
      size={size}
      className={`flex items-center gap-1 px-2 ${className}`}
      onClick={handleCopy}
    >
      <span className="sr-only">Copy ID</span>
      {copied ? (
        <Check className="h-4 w-4" />
      ) : (
        <>
          <span className="text-xs text-muted-foreground">
            {id.substring(0, truncateLength)}...
          </span>
          <Copy className="h-3 w-3 ml-1" />
        </>
      )}
    </Button>
  );
}
